import { render } from "./ChatPhoto.vue?vue&type=template&id=620603d0"
import script from "./ChatPhoto.vue?vue&type=script&lang=js"
export * from "./ChatPhoto.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__